// apps/frontend/src/lib/communityVoiceCopy.ts
// Catalogue de copy user-facing pour Community Voice.
// Le mot "sondage" ou "survey" ne doit jamais fuiter cote user :
// on parle de "question", "ton avis", "tes retours". Centralise ici
// pour eviter qu'un dev distrait n'ecrive "Soumettre le sondage".

export const COMMUNITY_VOICE_COPY = {
  modalTitle: 'Marie-Amélie a une question pour toi',
  modalSubtitle: 'Ton avis compte vraiment',
  modalIntroDefault:
    "Quelques secondes seulement — ce que tu me dis ici m'aide vraiment à faire grandir Glowp avec toi.",
  ctaNext: 'Suivant',
  ctaSkip: 'Passer',
  ctaSubmit: 'Envoyer mon avis',
  ctaDismiss: 'Plus tard',
  thankYouTitle: 'Merci, ça nous aide vraiment',
  thankYouBody:
    'Chaque retour est lu, à la main. Si on peut en faire quelque chose, on revient vers toi.',
  signatureFounder: '— Marie-Amélie, fondatrice de Glowp',
  attachmentNone: 'Aucune réponse pour cette question',
  textPlaceholder: 'Ta réponse, libre…',
  // Settings page
  preferenceSectionTitle: 'Tes préférences de communication',
  preferenceQuestion: "À quelle fréquence veux-tu qu'on te demande ton avis ?",
  preferenceOptions: {
    NORMAL: {
      label: 'Normalement',
      hint: 'De temps en temps, quand on prépare une décision importante.',
    },
    OCCASIONAL: {
      label: 'Occasionnellement',
      hint: 'Plus rarement — uniquement les questions clés.',
    },
    RARE: {
      label: 'Rarement',
      hint: 'Le strict minimum.',
    },
    NEVER: {
      label: 'Jamais',
      hint: 'On ne te demandera plus rien (sauf urgence vraiment critique).',
    },
  },
} as const;

export type CommunityVoiceCopy = typeof COMMUNITY_VOICE_COPY;
